import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import VisionStatement from "../../components/VisionStatement";
import AboutUsSection from "./AboutUsSection";
import AdvisorsSection from "./AdvisorsSection";
import TeamSection from "./TeamSection";
import ValuePropositionSection from "./ValuePropositionSection";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AboutusPage() {
  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to the target section
    if (location.hash) {
      const scrollToElement = () => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      };

      // Attempt scrolling after a slight delay to ensure the DOM is fully rendered
      setTimeout(scrollToElement, 100);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>About Zwilling Labs - Pioneers in Digital Twin Technology</title>
        <meta
          name="description"
          content="Learn about Zwilling Labs' mission to empower the manufacturing sector with cutting-edge digital twin technology. Our AI-powered platform ensures sustainable, efficient, and compliant operations."
        />
      </Helmet>
      <div className="flex flex-col w-full bg-white">
        {/* Header */}
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />

        <div className="flex flex-col items-center gap-[100px] px-5 lg:gap-[120px] md:gap-[90px] sm:gap-[70px]">
          {/* About Us Section */}
          <AboutUsSection />

          {/* Vision and Mission Section */}
          <div className="container px-5">
            <div className="flex flex-col gap-5 md:gap-6 sm:gap-4">
              <VisionStatement className="w-full" />
              <VisionStatement
                featureTitle="Our Mission"
                descriptionText="To empower manufacturers with a unified digital-twin platform providing engineering and AI insights with remote factory monitoring and control to enable agile, data-driven manufacturing for maximizing efficiency, reducing costs, ensuring quality and compliance."
                className="w-full"
              />
            </div>
          </div>

          {/* Value Proposition Section */}
          <ValuePropositionSection />

          {/* Team Section */}
          <TeamSection />

          {/* Advisors Section */}
          <AdvisorsSection />
        </div>

        {/* Footer */}
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-5" />
      </div>
    </>
  );
}
